import { useContext , useState, useEffect} from 'react';

import classes from './NavigationButtons.module.scss';
import LoginContext from '../../../../store/login-context';
import idImg from '../../../../assets/img/bio_id.svg';
import passwordImg from '../../../../assets/img/password.svg';
import scImg from '../../../../assets/img/smart_card.svg';
import appImg from '../../../../assets/img/application.svg';
import passkeyImg from '../../../../assets/img/passkey.svg';


declare var _curLang: any;
declare function Translate(key: string): string;
declare var _loginMethodSmartphoneOtpUrl: any;
declare var _loginMethodWebauthnUrl: any;
declare function Translate(key: string): string;


const NavigationButtons = () => {
    
    const ctx = useContext(LoginContext);
     
    const [secondRowDisplay,setSecondRowDisplay] = useState(false);
    const [showPassKey, setShowPassKey] = useState(true);

    useEffect(() => {
        let pkView = sessionStorage.getItem('showPkBtn');
        if(pkView !== undefined && pkView === 'false'){
            setShowPassKey(false);
        }
    },[]);
      
    const handleAppClick = () => {        
        window.location = _loginMethodSmartphoneOtpUrl;
    };

    const handleAppPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleAppClick(); 
        }
    };

    const handleSmartCardClick = () => {        
        ctx.scSelected();
    };

    const handleSmartCardPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleSmartCardClick();
        }
    };

    const handleBioIdClick = () => {        
        ctx.bioIdSelected();
    };

    const handleBioIdPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleBioIdClick();
        }
    };

    const handlekeyPassClick = () => {                
        window.location = _loginMethodWebauthnUrl;
    };

    const handleKeyPassPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handlekeyPassClick();
        }
    };

    const handleShowSecondButtonRow = () => {
        setSecondRowDisplay(true);
    };

    
    return (  
        <>
        {showPassKey && 
        <div className={classes['navigation-form-container']}>

            <h3 className={`${classes['navigation-form']} text-center`}>
                <label htmlFor="">{Translate('N_General_SignUp_register_options')}</label>
            </h3> 
           
            <div className={`${classes['navigation-buttons-container']} ${classes['navigation-form']} mt-3`}>
                {/* passkey */}
                <div 
                    id='passkeyContainer'
                    tabIndex={0}
                    role="button"
                    className={classes['nav-button']}
                    onClick={handlekeyPassClick}
                    onKeyPress={handleKeyPassPress}                                    
                >
                    <div className={classes.pk_temp}>
                        <span>{Translate('N_General_Recommended')}</span>
                    </div>   
                    <img
                        className={classes['nav-btn-image']}
                        src={passkeyImg}
                        aria-hidden="true"
                    />
                    <div className={classes['nav-btn-label']}>
                        {Translate('N_Login_Quick_Entry')}                    
                    </div> 
                                   
                </div>  

                {/* bio id */}
                <div 
                    id='bioIdContainer'
                    tabIndex={0}
                    role='button'
                    className={classes['nav-button']} 
                    onClick={handleBioIdClick}
                    onKeyPress={handleBioIdPress}                    
                >            
                    <img
                        className={classes.bio_id_img}
                        src={idImg}
                        aria-hidden="true"                                                        
                    />
                    <div className={
                        _curLang === 'ru'
                        ? classes['nav-btn-label-ru']
                        : classes['nav-btn-label']
                    }>
                        {Translate('N_Login_biometric_id_tab_title')}                            
                    </div>
                </div> 

                {/* smart card */}
                <div 
                    id='smartCardContainer'
                    tabIndex={0}
                    role='button' 
                    className={classes['nav-button']}
                    onClick={handleSmartCardClick}
                    onKeyPress={handleSmartCardPress}                                            
                >           
                    <img 
                        className={classes['nav-btn-image']} 
                        src={scImg} 
                        aria-hidden="true"   
                    />
                    <div className={classes['nav-btn-label']}>
                        {Translate('N_Login_smart_card_tab_title')}                            
                    </div>
                </div> 
            </div>                                          
        </div> 
        }  
        </>                               
    );
};

export default NavigationButtons;